import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat.js';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';

import {isString} from './index.js';
import type {ScheduleTime} from '#lit/types/journey/schedule.js';
import type {DateInputString, HourAndMinuteString} from '#lit/types/general.js';

dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

export function setScheduleTime(value: Date | string | number): ScheduleTime {
  const date = dayjs(value);
  const result = date.format('YYYY-MM-DDTHH:mm') as ScheduleTime;
  return result;
}

export function isDateInputString(value: unknown): value is DateInputString {
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  if (!isString(value)) return false;
  return regex.test(value);
}

export function isHourAndMinuteString(
  value: unknown
): value is HourAndMinuteString {
  const regex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  if (!isString(value)) return false;
  return regex.test(value);
}

export function getTimestampFromNow(includeMillisecond = true): string {
  const now = dayjs();
  return includeMillisecond
    ? now.format('HH:mm:ss:SSS')
    : now.format('HH:mm:ss');
}

/**
 * Takes a date and generates a valid date sring to use with HTML
 * date inputs.
 */
export function createHTMLDateString(date: Date) {
  return date.toISOString().split('T')[0];
}
